import { useState, useEffect } from "react";
import { Box, Grid, Paper, Snackbar } from "@mui/material";
import Layout from "../components/DashboardLayout";
import DashboardHeader from "../components/Dashboard/DashboardHeader";
import DriverTabs from "../components/Drivers/Tabs";
import DriverList from "../components/Drivers/List";
import DriverDetailPanel from "../components/Drivers/DetailPanel";
import { Helmet } from "react-helmet-async";
import { useRef } from "react";
import type { DriverDetailHandle } from "../components/Drivers/DetailPanel";

import { getDrivers } from '../api/drivers';


export interface Product {
  id: string;
  full_name: string;
  dni: string;
  status_id: number;
}


export default function DriversPage() {
  const detailRef = useRef<DriverDetailHandle>(null);
  const [isCreating, setIsCreating] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [tab, setTab] = useState<"active" | "inactive">("active");
  const [selectedProduct, setSelectedProduct] = useState<any>(null);
  const [search, setSearch] = useState("");
  const [products, setProducts] = useState<Product[]>([]);

  const fetchProducts = async () => {
    const res = await getDrivers();
    if (res.data.status) {
      setProducts(res.data.data);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  const filtered = products.filter((p) => {
    const isActive =
      tab === "active"
        ? p.status_id === 1
        : p.status_id !== 1

    return (
      isActive &&
      p.full_name.toLowerCase().includes(search.toLowerCase())
    );
  });

  const handleProductUpdated = () => {
    setSnackbarOpen(true);
    fetchProducts();
    setSelectedProduct(null);
  };

  const handleSelectProduct = (product: Product) => {
    if (detailRef.current && !detailRef.current.canLeave()) {
      return;
    }

    setIsCreating(false);
    setSelectedProduct(product);
  };

  return (
    <Layout>


      <Helmet>
        <title>Rodaris - Conductores</title>
      </Helmet>

      
      <DashboardHeader
        title="Conductores"
        onAddFilter={() => {
          if (detailRef.current && !detailRef.current.canLeave()) {
            return;
          }

          setSelectedProduct(null);
          setIsCreating(true);
        }}
      />

      <Box sx={{ p: 4 }}>
        <Grid container spacing={4}>
          {/* LISTA IZQUIERDA */}
          <Grid item xs={12} md={4}>
            <Paper
              elevation={0}
              sx={{
                height: "75vh",
                borderRadius: "18px",
                border: "1px solid #e6e6e6",
                backgroundColor: "#fff",
                overflow: "hidden",
              }}
            >
              <DriverTabs tab={tab} onChange={setTab} />

              {/* Buscador */}
              <Box sx={{ px: 2, pt: 1.5 }}>
                <input
                  placeholder="Buscar motorizado..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "10px 12px",
                    borderRadius: "10px",
                    border: "1px solid #e0e0e0",
                    fontSize: "13px",
                    fontFamily: "Poppins, sans-serif",
                    outline: "none",
                    background: "#fafafa",
                  }}
                />
              </Box>

              
              <DriverList
                products={filtered}
                selectedProduct={selectedProduct}
                onSelect={handleSelectProduct}
                onRefresh={fetchProducts}
              />

            </Paper>
          </Grid>

          {/* PANEL DERECHA */}
          <Grid item xs={12} md={8}>
            <Paper
              elevation={0}
              sx={{
                height: "75vh",
                borderRadius: "18px",
                border: "1px solid #e6e6e6",
                overflow: "hidden",
                backgroundColor: "#fff",
              }}
            >
              <DriverDetailPanel
                ref={detailRef}
                driver={selectedProduct}
                isCreating={isCreating}
                onCancel={() => {
                  setSelectedProduct(null);
                  setIsCreating(false);
                }}
                onSaved={handleProductUpdated}
              />

            </Paper>
          </Grid>
        </Grid>
      </Box>



      <Snackbar
        open={snackbarOpen}
        autoHideDuration={2500}
        onClose={() => setSnackbarOpen(false)}
        message="Producto actualizado correctamente"
      />

      
    </Layout>
  );
}
